import { render, staticRenderFns } from "./SliceVisual.vue?vue&type=template&id=39ded6c6&scoped=true"
import script from "./SliceVisual.vue?vue&type=script&lang=js"
export * from "./SliceVisual.vue?vue&type=script&lang=js"
import style0 from "./SliceVisual.vue?vue&type=style&index=0&id=39ded6c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ded6c6",
  null
  
)

export default component.exports